import React from "react";
import { Typography as MuiTypography, Box as MuiBox } from "@mui/material";
import PropTypes from "prop-types";

const BigMetric = ({ value, label }) => (
  <MuiBox>
    <MuiTypography
      sx={{
        fontSize: 144,
        fontWeight: 500,
        lineHeight: 1,
        color: "#4B4B4B",
      }}
    >
      {value}
    </MuiTypography>
    <MuiTypography color="text.secondary" mt={1} sx={{ fontSize: 14 }}>
      {typeof label === "string"
        ? label.split("\n").map((line, idx, arr) =>
            line !== "" ? (
              <span key={idx}>
                {line}
                {idx < arr.length - 1 && <br />}
              </span>
            ) : idx < arr.length - 1 ? (
              <br key={idx} />
            ) : null,
          )
        : label}
    </MuiTypography>
  </MuiBox>
);

BigMetric.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default BigMetric;
